'use strict';

export class P2PCampaigns {
    #campaignGoal;
    #userRegistrationForm;
    #campaignRegistrationForm;
    #campaignDetailsForm;
	#sponsorshipOpportunity;
	#p2pCampaignCurrency;
    constructor() {
        const campaignCurrency = document.querySelector( '#campaign-currency' );
		if (campaignCurrency) {
			campaignCurrency.removeAttribute('disabled');
		}
        this.#campaignGoal = document.querySelector( 'select[name="campaign_goal"]' );
		if (this.#campaignGoal) {
			this.#campaignGoal.removeAttribute('disabled');
		}
        this.#userRegistrationForm = document.getElementById( 'create-user-form' );
        this.#campaignRegistrationForm = document.getElementById( 'create-user-form' );
        this.#campaignDetailsForm = document.getElementById( 'p2p-campaign-details-form' );
		this.watchCampaignCurrency(campaignCurrency);
        this.admin_ajax = admin_ajax[0];
		this.#toggleMethodsForP2PGoalCreations();


		this.#p2pCampaignCurrency = document.querySelector('.p2p-campaigns .campaign-currency');
		if (this.#p2pCampaignCurrency) {
			this.changeVisibleSponsorships();
		}
    }

	changeVisibleSponsorships() {
		this.#sponsorshipOpportunity = document.querySelector('.selected_sponsorship_opportunity_wrapper');
		if (!this.#sponsorshipOpportunity) return;

		const selectElement = this.#sponsorshipOpportunity.querySelector('select');
		const choicesList = this.#sponsorshipOpportunity.querySelector('.choices__list--dropdown');

		const firstOptions = selectElement.querySelectorAll('option');
		firstOptions.forEach(option => {
			if (option.getAttribute('data-currency') === 'all') {
				option.style.display = 'block';
			} else {
				option.style.display = 'none';
			}
		});


		const firstChoiceItems = choicesList.querySelectorAll('.choices__item--choice');

		firstChoiceItems.forEach(choice => {
			const value = choice.getAttribute('data-currency');

			if (value === 'all') {
				choice.style.display = 'block';
			} else {
				choice.style.display = 'none';
			}
		});


		this.#p2pCampaignCurrency.addEventListener('change', (event) => {
			const selectedCurrency = event.target.value;
			const options = selectElement.querySelectorAll('option');
			options.forEach(option => {
				const optionCurrency = option.getAttribute('data-currency');
				option.style.display = (optionCurrency === selectedCurrency || optionCurrency === 'all') ? 'block' : 'none';
			});
			const choiceItems = choicesList.querySelectorAll('.choices__item--choice');

			choiceItems.forEach(choice => {
				const value = choice.getAttribute('data-currency');
				const matchingOptions = selectElement.querySelectorAll(`option[data-currency="${value}"]`);

				const isAnyMatchingOptionVisible = Array.from(matchingOptions).some(option => {
					return window.getComputedStyle(option).display !== 'none';
				});

				choice.style.display = isAnyMatchingOptionVisible ? 'block' : 'none';

			});
			const firstVisibleOption = selectElement.querySelector('option[style="display: block;"]');
			if (firstVisibleOption) {
				selectElement.value = firstVisibleOption.value;
			} else {
				selectElement.value = '';
			}
		});
	}


	watchCampaignCurrency(currencySelect) {
		if (!currencySelect) {
			return;
		}

		const goals = document.querySelectorAll('option.levcharity_p2p_campaign_goal');

		if (currencySelect.value !== '') {
			goals?.forEach((goal) => {
				const goalValue = goal.dataset[currencySelect.value.toLowerCase()]
				if (goalValue) {
					goal.textContent = `${goalValue} - `.concat(goal.textContent) ;
				}
			});
		}

		currencySelect.addEventListener('change', () => {
		if (currencySelect.value !== '') {
			const selectedCurrency = currencySelect.value;
			goals?.forEach((goal) => {
				const goalValue = goal.dataset[selectedCurrency.toLowerCase()]
				if (goalValue) {
					if (goal.textContent.includes(' - ')) {
						const choppedParts = goal.textContent.split(' - ');
						const choppedString = choppedParts.slice(1).join(' - ');
						goal.textContent = `${goalValue} - `.concat(choppedString) ;
					} else {
						goal.textContent = `${goalValue} - `.concat(goal.textContent) ;
					}
				}
			});
		} else {
			goals?.forEach((goal) => {
				if (goal.textContent.includes(' - ')) {
					const choppedParts = goal.textContent.split(' - ');
					goal.textContent = choppedParts.slice(1).join(' - ');
				}
			});
		}
	})
	}

	#toggleMethodsForP2PGoalCreations() {
		const p2pGoalsContainer = document.querySelector('.levcharity_p2p_goal_container');
		const sponsorshipOpportunitiesGoalsContainer = p2pGoalsContainer?.querySelector('.sponsorship_opportunities_container');
		const customGoalsContainer = p2pGoalsContainer?.querySelector('.custom_goals_container');

		//TODO: we should also clear set goals if a container is hidden

		document.addEventListener('change', (event) => {
			if (event.target.matches('input.activate_p2p_goals_from_sponsorship_opportunities')) {
				if(event.target.checked){
					sponsorshipOpportunitiesGoalsContainer?.classList.remove('hidden');
					customGoalsContainer?.classList.add('hidden');
				} else {
					sponsorshipOpportunitiesGoalsContainer?.classList.add('hidden');
					customGoalsContainer?.classList.remove('hidden');
				}
			}
		})
	}

	disableCustomP2PGoalRequireAttribute() {
		const selectSponsorshipOpportunity = document.querySelector('.selected_sponsorship_opportunity_wrapper select');
		const selectRazersEdgeNXTFund = document.querySelector('.selected_razers_edge_nxt_fund_wrapper select');
		const campaignGoal = document.querySelector('select[name="campaign_goal"]');

		selectSponsorshipOpportunity?.addEventListener('change', (event) => {
			if (event.target.value) {
				campaignGoal?.removeAttribute('required');
			} else  {
				campaignGoal?.setAttribute('required', 'required');
			}
		});
		selectRazersEdgeNXTFund?.addEventListener('change', (event) => {
			if (event.target.value) {
				campaignGoal?.removeAttribute('required');
			} else  {
				campaignGoal?.setAttribute('required', 'required');
			}
		});
	}
}
